const $ = require('jquery')
window.$ = $

export default {
	setTheme: function (tosave, _val) {
		let val = ''
		if (tosave == false) {
	    	let theme = document.cookie
	    	let themes = theme.split(';')
	    	themes.forEach(function (t) {
	    	    let tt = t.split('=')
	    	    if (tt.length == 2 && tt[0] == 'ssotheme') {
	    	    	val = tt[1]
	    	    }
	    	})
		} else {
			val = _val
		}
	    let ids = ['ServicesPage', 'LoginPage']
	    switch (val) {
	        case 'amour': 
	            ids.forEach(function (_id) { $('#' + _id).css('background-image', "linear-gradient(to top, #f77062 0%, #fe5196 100%)") })
	            break;
	        case 'blue': 
	            ids.forEach(function (_id) { $('#' + _id).css('background-image', "linear-gradient(to top, #4481eb 0%, #04befe 100%)") })
	            break;
	        case 'black': 
	            ids.forEach(function (_id) { $('#' + _id).css('background-image', "linear-gradient(to right, #434343 0%, black 100%)") })
	            break;
	        case 'gray': 
	            ids.forEach(function (_id) { $('#' + _id).css('background-image', "linear-gradient(to top, #c4c5c7 0%, #dcdddf 52%, #ebebeb 100%)") })
	            break;
	        case 'green': 
	            ids.forEach(function (_id) { $('#' + _id).css('background-image', "linear-gradient(-60deg, #16a085 0%, #f4d03f 100%)") })
	            break;
	    }
	}
}